import { setShowValuationCompletionModal } from '../State/showValuationCompletionModal';
import { setSelectedOrderGroupKeys } from '../State/selectedOrderGroupKeys';

export default () => async (dispatch) => {

  dispatch(setShowValuationCompletionModal(false));
  dispatch(setSelectedOrderGroupKeys(null));
  
}